import React, { Component, } from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import Firebase from 'firebase'

import _ from 'lodash'

import PropTypes from 'prop-types';

import {CCUtils, CCActions,  CCLBStatusItem, Constants, DataActionTypes as DataAT,  images,strings, CCSideBarSubLayout} from "./../../cc-imports";
import CCListView from "../../components/CCListView/CCListView2";
import CCSectionList from "../../components/CCSectionList/CCSectionList";
import './../../styles/css/screens/Leaderboard/leader-board.css'
import CCErrorBoundary from "../../components/CCErrorBoundary/CCErrorBoundary";
import {CCUIUtils} from "../../lib/CCUIUtils";


 class Leaderboard extends Component {

    static propTypes = {
        sponsorKey:PropTypes.string,
        onBackPress : PropTypes.func
    }

    static defaultProps = {
        sponsorKey:Constants.cricrushSponsor,
        onBackPress : ()=>{}
    }

    constructor(props) {
        super(props)
        this.initialState ={
            title : 'Leader Board',

            type : undefined, // weekly, monthly, lifetime
            country : undefined, //ALL or LOCAL
            subType : undefined, // NO_OF_COINS_EARNED, NO_OF_ENTRIES_PLAYED, WIN_LOST_RATIO
            status : 'ACTIVE', // active, COMPLETED

            types : [],
            countries : [],
            subTypes : [],
            statuses : [],

            lbId : '',
            lb : {},
            data : [],
            skip : 0
        };
        this.state = this.initialState;
        this._updateSelectedLb=this._updateSelectedLb.bind(this);
        this._updateLBMapsAndGetDefaultLB=this._updateLBMapsAndGetDefaultLB.bind(this);
        this._updateCountry=this._updateCountry.bind(this);
        this._updateStatus=this._updateStatus.bind(this);
        this._paginate=this._paginate.bind(this);
        this._manualRefresh=this._manualRefresh.bind(this);
        this._updateType=this._updateType.bind(this);
        this._updateCountry=this._updateCountry.bind(this);
        this._getTitleForType=this._getTitleForType.bind(this);
        this._getTitleForCountry=this._getTitleForCountry.bind(this);
        this._getLbsForSponsor=this._getLbsForSponsor.bind(this);
    }

     _renderSectionHeader = ({section}) => {
         return (
             <div>
                 <h1>{section.key}</h1>
             </div>
         )
     }

    componentWillMount() {

    }

     _getLbsForSponsor(sponsorKey) {
        const {lbs} = this.props;
        const{byId,bySponsor}=lbs;
        var newLbs = [];
        if(bySponsor[sponsorKey]){
            _.forEach(bySponsor[sponsorKey] , (lbBySponsor) => {
                if(byId[lbBySponsor]){
                    newLbs = _.unionBy(newLbs, [byId[lbBySponsor]], 'id')
                }
            })
        }
        newLbs = CCUtils.sortLbs(newLbs);
        return newLbs;
    }

    _loadLbs() {
        Firebase.auth().currentUser && Firebase.auth().currentUser.getIdToken(false).then((idToken)=> {
            const {user, userId} = this.props;
            this.props.actions.fetchLBs({accessToken:idToken}, {userId : userId, sponsorKey : this.props.sponsorKey}, DataAT.GET).then(()=>{
                this._updateLBMapsAndGetDefaultLB(this._getLbsForSponsor(this.props.sponsorKey), user, (defaultLB)=> {
                    if(defaultLB) {
                        this.setState({lbId:defaultLB.id, lb : defaultLB}, ()=>{
                            this._fetchLbStatuses(defaultLB.id,0,20,DataAT.GET);
                        })
                    }
                });
            })
        })
    }

    componentDidMount() {
        this.setState(this.initialState);
        this._loadLbs();
    }

    _updateLBMapsAndGetDefaultLB(lbs, user, callback) {
        var types = [];
        var countries = [];
        var subTypes = [];
        var statuses = [];

        var defaultLB = undefined;

        _.forEach(lbs,(lb) => {

            types = _.union(types, [lb.type]);
            countries = _.union(countries, [lb.country]);
            subTypes = _.union(subTypes, [lb.subType]);
            statuses = _.union(statuses, [lb.status]);

            if(lb.sponsor && lb.sponsor.key && lb.sponsor.key != Constants.cricrushSponsor) {
                defaultLB = lb;
            }
        });

        defaultLB = !defaultLB ? _.find(lbs, (lb)=>{ return (lb.type=='LIFETIME') }): undefined;
        defaultLB = !defaultLB ? _.find(lbs, (lb)=>{ return (lb.type=='MONTHLY') }): undefined;
        defaultLB = !defaultLB ? _.find(lbs, (lb)=>{ return (lb.type=='WEEKLY') }): undefined;
        defaultLB = !defaultLB ? _.find(lbs, (lb)=>{ return (lb.type=='SEASON') }): undefined;

        defaultLB = !defaultLB ? lbs[0] : undefined;

        this.setState({
            types,
            countries,
            subTypes,
            statuses,
            type : defaultLB.type,
            country : defaultLB.country,
            subType : defaultLB.subType,
            status : defaultLB.status
        }, callback(defaultLB));

    }

    _fetchLbStatuses(lbId, skip, limit, type){
        //console.log("fetch lb statuses")
        Firebase.auth().currentUser && Firebase.auth().currentUser.getIdToken(false).then((idToken)=>{
            const user = this.props.user;
            this.props.actions.fetchLBStatuses({accessToken:idToken}, {userId : (user && user.id) ? user.id : Constants.anonymousUser, lbId:lbId,skip:skip,limit:limit},type).then(()=>{
                this._updateLBStatuses(lbId);
            }).catch(()=>{
                this._updateLBStatuses(lbId);
            })
        })
    }


    _updateLBStatuses(lbId) {
        const {userId}=this.props;
        const {byLbId,lbStatuses} = this.props.lbStatuses;
        var lbStatusesIds = byLbId[lbId];
        var lbStatusesById =lbStatuses;
        var data = [];
        if(lbStatusesIds){
            var newLbStatuses = [];
            _.forEach(lbStatusesIds, (lbStatusesId)=>{
                newLbStatuses.push(lbStatusesById[lbStatusesId]);
            })

            //console.log(this.props.user)
            var ownLbStatus = _.filter(newLbStatuses,(status)=>{
                return status.user.id==userId;
            });
            if(ownLbStatus && ownLbStatus.length>0){
                data.push({
                    data : ownLbStatus
                })
            }

            newLbStatuses = _.sortBy(newLbStatuses,['rank']);

            var winningLbStatuses = _.filter(newLbStatuses,{'rewardWinning':true});
            var notWinningLbStatuses = _.filter(newLbStatuses,{'rewardWinning':false});

            if(winningLbStatuses && winningLbStatuses.length>0){
                data.push({
                    data : winningLbStatuses
                });
            }

            if(notWinningLbStatuses && notWinningLbStatuses.length>0){
                data.push({
                    data : notWinningLbStatuses
                });
            }


        }
        this.setState({data});
    }

    _updateSelectedLb() {
        var {type , subType ,  country , status  } = this.state;
        const {lbs, lbStatuses} = this.props;
        var lb = undefined;

        _.forIn(lbs.byId, (value, key)=>{
            if (value.sponsor && value.sponsor.key==this.props.sponsorKey &&
                (value.country == country || value.country=='ALL')&&
                value.type == type &&
                value.subType == subType &&
                (value.status == status || value.type==Constants.lbType.LIFETIME )

            ){
                lb = value;
            }
        });

        if(!lb){
            lb = {id : 'none'};
        }

        if(this.state.lbId != lb.id){
            if(!lbStatuses.byLbId[lb.id]){
                this.setState({skip:0},()=>{
                    this._fetchLbStatuses(lb.id, this.state.skip, 20, DataAT.GET);
                })
            }
            else {
                this._updateLBStatuses(lb.id);
            }
            this.setState({lbId : lb.id, lb:lb});
        }

    }

    _updateType(type) {
        this.setState({type},  this._updateSelectedLb);
    }

     _updateCountry(country) {
         this.setState({country},  this._updateSelectedLb);
     }

     _updateStatus(status) {
         this.setState({status},  this._updateSelectedLb);
     }

     _manualRefresh(){
         this._fetchLbStatuses(this.state.lbId, 0, this.state.skip*20, DataAT.MANUAL_REFRESH);
     }

     _paginate(){
        const {reqStatus} = this.props;
         if(reqStatus!=Constants.reqStatus.COM){
             this._fetchLbStatuses(this.state.lbId, this.state.skip+1, 20, DataAT.PAGINATE);
             this.setState({skip:this.state.skip+1});
         }
     }

     _getBgColor(title) {
        if(this.state.country==title){
            return '#082857'
        }
        else {
            return '#11428C'
        }
     }

     _getTitleForType(type) {
        switch (type){
            case (Constants.lbType.DAILY):
                return strings('daily');
                break;
            case (Constants.lbType.WEEKLY):
                return strings('weekly');
                break;
            case (Constants.lbType.MONTHLY):
                return strings('monthly');
                break;
            case (Constants.lbType.LIFETIME):
                return strings('lifetime');
                break;
        }
     }

     _getTitleForCountry(country, user) {
        if(country && user && user.country && country==user.country){
            return strings('local');
        }
        else {
            return strings('global')
        }
     }

     _getCountryStyle(index, length, country, selectedCountry) {
         var cName = "country-heading";

         if (selectedCountry == country) {
             cName = cName + ' selected'
         }

         if (length == 1) {
             return cName;
         }
         else if (index == 0) {
             return cName + ' left';
         } else if (index == length - 1) {
             return cName + ' right';
         }
         else {
             return cName;
         }
     }



    render() {
        const {reqStatus, lbStatuses, lbs, type, user} = this.props;

        const { types, countries, subTypes, statuses, lb, status } = this.state;

        const data = this.state.data;
        const selectedType = this.state.type;
        const selectedCountry= this.state.country;

        return (
            <CCErrorBoundary>
                <div className={"flex-container"} style={{flex:1}} >
                    <div className="flex-container image-leader-board-background" style={{flex:1}}>
                        <div className="leader-board-background-2">
                            <div className="flex-container leader-board-header" >
                                <h1>{strings('leaderBoard')}</h1>
                            </div>
                            <div className="flex-container btn type" >
                                {
                                    types.map((type)=>{
                                        return(
                                            <div className="flex-container" onClick={()=>{this._updateType(type)}}>
                                                <h1 key={type} clickable={true} className={'leader-board-type-txt '+ (selectedType==type?'selected':'')}>{this._getTitleForType(type)}</h1>
                                            </div>)
                                    })
                                }
                            </div>

                            {
                                (this.state.type!=Constants.lbType.LIFETIME && user.id != undefined && user.country!=undefined) &&
                                <div className="flex-container btn country">
                                    {
                                        countries.map((country, index)=>{
                                            return (
                                                <div  className={this._getCountryStyle(index, countries.length, country, selectedCountry)} key={country} onClick={()=>{ this._updateCountry(country) }} style={[{backgroundColor: this._getBgColor(country),}, this._getCountryStyle(index, countries.length)]}>
                                                    <h1>{this._getTitleForCountry(country, user)}</h1>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            }
                            {
                                (this.state.type!=Constants.lbType.LIFETIME) &&
                                <div className="flex-container life-time" >
                                    <div className={'flex-container'} style={{flex:1, alignItems:'flex-start'}}>
                                        {
                                            status == Constants.lbStatus.ACTIVE &&
                                            <h1 className="arrow " onClick={()=>{this._updateStatus(Constants.lbStatus.COMPLETED)}} clickable={true}>{"<<"}</h1>

                                        }
                                    </div>
                                    <div className={'flex-container'} style={{flex:4}}>
                                        <h4 className={'lb-date-range'}>{CCUtils.formatDate(lb.startDate)}</h4>
                                        {
                                            (lb.startDate && lb.endDate) &&
                                            <h4 className={'lb-date-range-divider'}>{"-"}</h4>
                                        }
                                        <h4 className={'lb-date-range'}>{CCUtils.formatDate(lb.endDate)}</h4>
                                    </div>
                                    <div className={'flex-container'} style={{flex:1,alignItems:'flex-end', flexDirection:'row'}}>
                                        {
                                            status == Constants.lbStatus.COMPLETED &&
                                            <h1 className="arrow" onClick={()=>{this._updateStatus(Constants.lbStatus.ACTIVE)}} clickable={true} >{">>"}</h1>
                                        }
                                    </div>

                                </div>
                            }

                            <div style={{flex:1}}>
                                {
                                    <CCSectionList
                                        onEndReached={this._paginate}
                                        onEndReachedThreshold={1}
                                        renderItem={(lbStatus) => <CCLBStatusItem currentUser={user} lbStatus={lbStatus} key={lbStatus.id}></CCLBStatusItem>}
                                        renderSectionHeader={({section}) => <div className={'lb-divider'}><img src={images.icons.lb_divider} style={{width:'80%', resizeMode : 'contain'}}></img></div>}
                                        sections={this.state.data}
                                        ListFooterComponent={CCUIUtils.getListFooter(reqStatus, type, this.state.data)}
                                        ListEmptyComponent={CCUIUtils.getEmptyListItem(reqStatus)}

                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </CCErrorBoundary>

        )
    }
}

export default connect(state=>({
    user : state.user.user,
    userId: state.user.user.id ? state.user.user.id : Constants.anonymousUser,
    lbs : state.leaderBoard.lbs,
    lbStatuses : state.leaderBoard.lbStatuses,
    reqStatus : state.leaderBoard.reqStatus,
    error : state.leaderBoard.error,
    random : state.leaderBoard.random,
    type : state.leaderBoard.type
}), (dispatch)=>({
    actions: bindActionCreators({...CCActions}, dispatch),
    dispatch: dispatch
}))(Leaderboard);



// WEBPACK FOOTER //
// ./src/app/screens/Leaderboard/Leaderboard.js